export default RAILS_ASSET_URL("/login_google.svg")
